import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Directive({
  selector: '[appApiCallLoading]',
  standalone: true
})
export class ApiCallLoadingDirective {
  @Input() public loading: boolean;
  @Input() public appApiCallLoading: (value?: any) => Observable<any>;
  @Output() public loadingChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  @Input()
  @HostBinding('disabled')
  disabled: boolean;

  private internalLoading = false;

  constructor() {}

  @HostListener('click')
  public onClick(): void {
    if (!this.internalLoading && !this.disabled) {
      this.loadingOn();

      this.appApiCallLoading()
        .pipe(finalize(() => this.loadingOff()))
        .subscribe();
    }
  }

  private loadingOn(): void {
    this.internalLoading = true;
    this.loadingChange.emit(true);
  }

  private loadingOff(): void {
    this.internalLoading = false;
    this.loadingChange.emit(false);
  }
}
